export default __webpack_public_path__ + "static/media/icon-plus.ac3ec6ff.svg";